import { createFileRoute } from '@tanstack/react-router';
import { buildCanonicalLink, buildMeta } from '@/lib/seo';
import { ssrForPublicOnly } from '@/lib/ssr-utils';

export const Route = createFileRoute('/accessibility/')({
  ssr: ssrForPublicOnly,
  head: () => ({
    meta: buildMeta({
      title: 'הצהרת נגישות - Pricedrop',
      description: 'Pricedrop מחויב לספק חווית שימוש נגישה לכלל המשתמשים.',
      canonicalUrl: '/accessibility',
    }),
    links: [buildCanonicalLink('/accessibility')],
  }),
  component: AccessibilityPage,
});

function AccessibilityPage() {
  return (
    <div className="mx-auto max-w-4xl rounded-lg bg-card p-6 shadow-md">
      <h1 className="mb-6 text-3xl font-bold">הצהרת נגישות</h1>

      <section className="mb-8">
        <h2 className="mb-4 text-2xl font-semibold">מבוא</h2>
        <p>
          אתר <strong>Pricedrop.co.il</strong> מחויב להעניק חוויית שימוש שוויונית ונגישה לכלל
          הציבור, כולל אנשים עם מוגבלויות. אנו שואפים להבטיח שהשירותים הדיגיטליים באתר יהיו נגישים
          בצורה קלה, ברורה ומכבדת, בהתאם להוראות חוק שוויון זכויות לאנשים עם מוגבלות,
          התשנ&quot;ח-1998 ותקנות הנגישות בישראל.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="mb-4 text-2xl font-semibold">התאמות נגישות באתר</h2>
        <ul className="list-inside list-disc space-y-2">
          <li>
            התאמה לתקן: האתר עומד בדרישות תקן ישראלי ת&quot;י 5568 המבוסס על הנחיות WCAG 2.1 ברמה
            AA.
          </li>
          <li>
            ניווט באמצעות מקלדת: ניתן לגלוש באתר ולהפעיל את מרבית הפונקציות באמצעות מקלדת בלבד.
          </li>
          <li>
            תמיכה במצב כהה (Dark Mode): האתר כולל מצב כהה המאפשר שימוש נוח לאנשים עם רגישות לאור.
          </li>
          <li>התאמה להגדלת טקסט: האתר מותאם לעבודת הגדלת טקסט בדפדפנים בצורה חלקה.</li>
          <li>תגיות אלט לתמונות: כל התמונות כוללות תיאור טקסטואלי חלופי.</li>
          <li>מבנה כותרות ברור: שימוש בכותרות ברורות ומסודרות להקלה על ניווט בתוכן.</li>
          <li>נגישות טפסים: שדות הטפסים מוגדרים בצורה נגישה.</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="mb-4 text-2xl font-semibold">סייגים לנגישות</h2>
        <p>
          ייתכן כי חלקים מסוימים באתר עדיין אינם נגישים במלואם. אנו ממשיכים לפעול על מנת לשפר את
          חוויית הנגישות ולהטמיע עדכונים נוספים בהקדם.
        </p>
      </section>

      <section>
        <h2 className="mb-4 text-2xl font-semibold">תאריך עדכון הצהרה</h2>
        <p>הצהרה זו עודכנה לאחרונה בנובמבר 2024.</p>
      </section>
    </div>
  );
}
